module.exports = __webpack_public_path__ + "img/star-active.bf6dca64.png";